
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/foodies",
      function () {
        return require("private-next-pages/search/foodies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/foodies"])
      });
    }
  